import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

import Entry from "../containers/Entry.vue";

// 自动外呼
const TmkAutoOutboundCall = () => import("../components/tmkClue/TmkAutoOutboundCall.vue");

// 机器人外呼
const TmkRobotOutboundCall = () => import("../components/tmkClue/TmkRobotOutboundCall.vue");

// 销售工作台
const HomeIndex = () => import("../components/home/HomeIndex.vue");

// 销售电话咨询
const CluesModuleSalesTracking = () => import("../components/cluesManage/CluesModuleSalesTracking.vue");

// 管理工作台
const Workbench = () => import("../components/home/Workbench.vue");

// 视图管理
const viewManage = () => import("../components/viewCustom/ViewManage.vue");

// 客户管理
const CluesIndex = () => import("../containers/CluesIndex.vue");

// 会场销售-客户管理
const MeetCluesIndex = () => import("../components/SalesManage/MeetCluesIndex.vue");

// 导入结果查询
const CluesModuleBatch = () => import("../components/cluesManage/CluesModuleBatch.vue");

// 获取新客户
const NewList = () => import("../components/newList/NewList.vue");

// 今日新客户
const SaleNewClueList = () => import("../components/SalesManage/SaleNewClueList.vue");

// 今日重复咨询
const RepeatConsult = () => import("../components/SalesManage/RepeatConsult.vue");

// 今日预约沟通
const ReservationComm = () => import("../components/SalesManage/ReservationComm.vue");

// 会场销售-今日新客户
const MeetNewClueList = () => import("../components/MeetManage/MeetNewClueList.vue");

// 会场销售-今日重复咨询
const MeetRepeatConsult = () => import("../components/MeetManage/MeetRepeatConsult.vue");

// 会场销售-今日待跟进
const MeetReservationComm = () => import("../components/MeetManage/MeetReservationComm.vue");

// 公海池
const SalePublicPoolClue = () => import("../components/SalesManage/SalePublicPoolClue.vue");

// 我的客户
const MyClient = () => import("../components/SalesManage/MyClient.vue");

// 我的学员
const MyStudent = () => import("../components/SalesManage/MyStudent.vue");

// 群管理
const GroupManagement = () => import("../components/GroupManagement/GroupManagement.vue");

// 聊天管理
const ChatManagement = () => import("../components/GroupManagement/ChatManagement.vue");

// 客户推荐
const RecommendClueList = () => import("../components/SalesManage/RecommendClueList.vue");

// 预约试听列表
const CluesInvitationAudition = () => import("../components/cluesManage/CluesInvitationAudition.vue");

// 特殊试听申请
const CluesSpeAudition = () => import("../components/cluesManage/CluesSpeAudition.vue");

// 我的定金
const OrderDeposit = () => import("../components/order/OrderDeposit.vue");

// 未完款订单
const OrderUnPaid = () => import("../components/order/OrderUnPaid.vue");

// 所有订单
const OrderManage = () => import("../containers/OrderManage.vue");

// 退回订单
const OrderReturn = () => import("../components/order/OrderReturn.vue");

// 新订单管理
const OrdermanageList = () => import("../components/order/OrdermanageList.vue");

// 待审核退款
const OrderRefundCheck = () => import("../components/order/OrderRefundCheck.vue");

// 待审核订单
const OrderAuditManage = () => import("../components/order/OrderAuditManage.vue");

// 订单收款
const OrderPaySerial = () => import("../components/order/OrderPaySerial.vue");

// 订单退款
const OrderRefund = () => import("../containers/OrderRefund.vue");

// 开票审核
const OrderTicketOpeningAudit = () => import("../components/order/OrderTicketOpeningAudit.vue");

// 产品管理
const ProductIndex = () => import("../containers/ProductIndex.vue");

// 产品包管理
const ProductPackIndex = () => import("../containers/ProductPackIndex.vue");

// 课程管理
const CourseManagement = () => import("../containers/CourseManagement.vue");

// 产品性质权限
const PropertyRelationList = () => import("../components/product/PropertyRelationList.vue");

// 通话记录查询
const CallRecord = () => import("../containers/CallRecord.vue");

// 通时通次排行
const AgentStatus = () => import("../components/callCenter/AgentStatus.vue");

// 座席状态监控
const CallMonitor = () => import("../components/callCenter/CallMonitor.vue");

// 报表页面
const ReportPages = () => import("../containers/Report.vue");

// 分配规则配置
const auditionIndex = () => import("../components/audition/index.vue");

// TMK分配配置
const tmkAllotSetting = () => import("../components/cluesManage/CluesModuleAssignRule.vue");

// TMK分配回收配置
const recovery = () => import("../components/cluesManage/CluesModuleAssignRuleRecovery.vue");

// 渠道管理
const channelManagement = () => import("../containers/channelManagement.vue");

// 渠道分类管理
const channelFenLeiManagement = () => import("../containers/channelFenLeiManagement.vue");

// 来源渠道管理
const Channel = () => import("../containers/Channel.vue");

// 客户来源管理
const CustomerSource = () => import("../containers/CustomerSource.vue");

// 营销计划管理
const MarketingList = () => import("../components/settingManage/MarketingList.vue");

// 字典维护
const DictionaryMaintenance = () => import("../components/settingManage/DictionaryMaintenance.vue");

// 报表权限
const ReportPermissions = () => import("../components/settingManage/ReportPermissions.vue");

// 优惠管理
const DiscountIndex = () => import("../containers/DiscountIndex.vue");

// 合作校管理
const SchoolManage = () => import("../containers/SchoolManage.vue");

// 消息列表
const MessageManage = () => import("../containers/MessageManage.vue");

// 视图管理
const ViewModuleManage = () => import("../components/settingManage/ViewModuleManage.vue");

// 业绩目标
const PerformanceTarget = () => import("../components/settingManage/PerformanceTarget.vue");

// 白名单
const WhiteList = () => import("../components/settingManage/WhiteList.vue");

// 系统发布
const ReleaseIndex = () => import("../components/Release/ReleaseIndex.vue");

// 用户群列表
const LabellingModuleManage = () => import("../components/settingManage/LabellingModuleManage.vue");

// 新建短信模板
const messageCreate = () => import("../components/messageCreate.vue");

// 我的模板列表
const Information = () => import("../containers/Information.vue");

// 消息统计
const InformationList = () => import("../components/InformationList.vue");

// 活动推广列表
const MarketingExpand = () => import("../components/settingManage/MarketingExpand.vue");

// 新建活动推广页
const MarketingAdd = () => import("../components/settingManage/MarketingActivity.vue");

// 营销活动奖品池
const MarketingPrize = () => import("../components/settingManage/MarketingPrize.vue");

// 新建市场营销活动
const MarketingSqueeze = () => import("../components/settingManage/MarketingAdd.vue");

// 登陆
const Login = () => import("../containers/Login.vue");

// 客户详情
const CluesModuleDetails = () => import("../components/cluesManage/CluesModuleDetails.vue");

// 会场销售客户详情
const MeetCluesModuleDetails = () => import("../components/cluesManage/MeetCluesModuleDetails.vue");

// 创建订单
const OrderModuleCreate = () => import("../components/order/OrderModuleCreate.vue");

// 订单审核
const OrderModuleAudit = () => import("../components/order/OrderModuleAudit.vue");

// 新增客户
const CluesModuleNewUsers = () => import("../components/cluesManage/CluesModuleNewUsers.vue");

// 新增会场销售客户
const MeetCluesModuleNewUsers = () => import("../components/cluesManage/MeetCluesModuleNewUsers.vue");

// 直播
const Jump = () => import("../containers/Jump.vue");

// 404
const Page404 = () => import("../components/Page404.vue");

// 用户合同
const CrmRegistrationForm = () => import("../components/order/CrmRegistrationForm.vue");

// 电子合同模板
const ContractTemplateList = () => import("../components/settingManage/ContractTemplateList.vue");

// 电子合同管理
const UserAgreementManage = () => import("../components/order/UserAgreementManage.vue");

// 用户合同资料
const UserAgreementMaterial = () => import("../components/order/UserAgreementMaterial.vue");

// 合同详情
const UserFileUpload = () => import("../components/order/UserFileUpload.vue");

// 中转页面
const Stage = () => import("../containers/Stage.vue");

// 金融用户合同
const FinancialRegistration = () => import("../components/order/FinancialRegistration.vue");

// 签署合同
const UserAgreementContract = () => import("../components/order/UserAgreementContract.vue");

// 修改密码
const UpdatePwd = () => import("../containers/UpdatePwd.vue");

// 新增标签
const AddLabelling = () => import("../components/settingManage/AddLabelling.vue");

// 新增视图
const AddView = () => import("../components/settingManage/AddView.vue");

// 视图管理
const ViewModuleCustom = () => import("../components/viewCustom/ViewModuleCustom.vue");

// 编辑发布记录
const AddReleaseInfo = () => import("../components/Release/AddReleaseInfo.vue");

// 查看发布记录
const ViewRelease = () => import("../components/Release/ViewRelease.vue");

// 查看报表
const ViewReport = () => import("../components/ViewReport.vue");

// 客户导入批次详情
const CluesModuleBatchDetail = () => import("../components/cluesManage/CluesModuleBatchDetail.vue");

// ERP登入CRM
const ErpLoginCrm = () => import("../components/automaticLogin.vue");

// 订单异常处理
const OrderTryCatch = () => import("../components/order/OrderTryCatch.vue");

// 市场调研
const MarketDistrict = () => import("../components/MarketDistrict/MarketMap.vue");

// 打卡记录
const PunchCardRecord = () => import("../components/PunchCard/PunchCardRecord.vue");

// 打卡
const PunchCard = () => import("../components/PunchCard/PunchCard.vue");

// 员工打卡记录
const StaffPunchCardRecord = () => import("../components/StaffPunchCard/StaffPunchCardRecord.vue");

// 员工打卡
const StaffPunchCard = () => import("../components/StaffPunchCard/StaffPunchCard.vue");

// 会场管理
const VenueList = () => import("../components/MarketDistrict/VenueList.vue");

// 签到详情
const SignInList = () => import("../components/MarketDistrict/SignInList.vue");

// 直播签到详情
const LiveInfo = () => import("../components/Invitation/InvitateModalLiveInfo.vue");

// 邀约管理
const InvitationList = () => import("../components/Invitation/InvitationList.vue");

// 营销会管理
const InvitedList = () => import("../components/Invitation/InvitedList.vue");

// 市调管理
const MarketSurveyList = () => import("../components/MarketSurvey/MarketSurveyList.vue");

// 公校管理
const PublicSchoolManage = () => import("../components/BasicsInformation/PublicSchoolManage.vue");

// 新增电邀
const TelephoneInvitation = () => import("../components/BasicsInformation/TelephoneInvitation.vue");

// 片区管理
const DistrictManage = () => import("../components/BasicsInformation/DistrictManage.vue");

// 楼盘管理
const EstateManagement = () => import("../components/product/EstateManagement.vue");

// 分类管理
const ContenDdisplay = () => import("../components/product/ContenDdisplay.vue");

// 地图片区
const TMap = () => import("../containers/TMap.vue");

// 地图片区
const TMapAll = () => import("../containers/TMapAll.vue");

// 标签预警设置
const LabelWarning = () => import("../components/LabelWarning/LabelWarning.vue");

// 我的好友
const MyFriend = () => import("../components/MyClients/MyFriend.vue");

// 我的客户
const MyClients = () => import("../components/MyClients/MyClients.vue");

// 竞品管理
const VieCommodity = () => import("../components/VieCommodity/VieCommodityList.vue");

// 电邀管理-今日新客户
const TmkNewClueList = () => import("../components/tmkClue/TmkNewClueList.vue");

// 电邀管理-今日重复咨询
const TmkRepeatConsult = () => import("../components/tmkClue/TmkRepeatConsult.vue");

// 电邀管理-今日待跟进
const TmkReservationList = () => import("../components/tmkClue/TmkReservation.vue");

// 电邀管理-我的线索
const TmkMyClient = () => import("../components/tmkClue/TmkMyClient.vue");

// 电邀管理-电邀公池
const TmkPublicPoolClue = () => import("../components/tmkClue/TmkPublicPoolClue.vue");

// 会场签到
const registerSignin = () => import("../components/registerSignin.vue");

// 会场签到
const PlayerIndex = () => import("../containers/PlayerIndex.vue");

// 回执单列表
const VenueReceiptList = () => import("../components/MarketDistrict/VenueReceiptList.vue");

// 服务内容配置
const ServiceCollocate = () => import("../components/Service/ServiceCollocate.vue");

// 经销商门店地图
const StoreMap = () => import("../components/MarketDistrict/StoreMap.vue");

// 服务内容分类
const ServiceClassify = () => import("../components/Service/ServiceClassify.vue");

// Sop标签管理
const TagAdminList = () => import("../components/SopManage/tagAdminList.vue");

// Sop视频管理
const SopVideoManage = () => import("../components/SopVideoManage/sopVideoList.vue");

// 新增/编辑内容管理
const ContentDesc = () => import("../components/SopManage/ContentDesc.vue");

// 内容管理列表
const ContentManagement = () => import("../components/SopManage/ContentManagement.vue");

// 推送记录
const PushRecord = () => import("../components/Record/PushRecord.vue");

// 用户行为记录
const BehaviorRecord = () => import("../components/Record/BehaviorRecord.vue");

// NEW素材库
const MaterialBank = () => import("../components/Record/MaterialBank.vue");

// Sop管理列表
const TmkSalesManagement = () => import("../components/tmkClue/TmkSalesManagement.vue");

// 推送记录
const TmkSalesPushRecord = () => import("../components/tmkClue/TmkSalesPushRecord.vue");

// 用户行为记录
const TmkSalesUserBehavior = () => import("../components/tmkClue/TmkSalesUserBehavior.vue");

// 邀约到店管理
const IndividualList = () => import("../components/Individual/IndividualList.vue");

// 排班日历
const SchedulingCalendar = () => import("../components/settingManage/SchedulingCalendar.vue");

// 电销排班
const SalesmanScheduling = () => import("../components/settingManage/SalesmanScheduling.vue");

// 校区管理
const CampusManagement = () => import("../components/CampusManagement/CampusManagement.vue");

// 广告管理
const AdvertisingManagement = () => import("../components/AdvertisingManagement/AdvertisingManagement.vue");

// 代理员管理
const Agent = () => import("../components/Agent/Agent.vue");

// 招商会意向客户
const RelatedExport = () => import("../components/MarketDistrict/RelatedExport.vue");

// 飞鱼返款对账单
const FeiyuRefund = () => import("../containers/FeiyuRefund.vue");

// 盘古系统-统计分析-销售报表-业绩明细
const SalesmanClueFollowUpReport = () => import("../containers/sales/SalesmanClueFollowUpReport.vue");

// 盘古系统-统计分析-销售报表-业绩明细
const PerformanceDetail = () => import("../containers/sales/performanceDetail.vue");

// 盘古系统-统计分析-会务报表-会议签到明细
const MeetingSignInDetail = () => import("../containers/conference/meetingSignInDetail.vue");

// 盘古系统-统计分析-销售报表-跟进汇总数据
const FollowUpAllData = () => import("../containers/sales/followUpAllData.vue");

// 盘古系统-统计分析-销售报表-跟进明细数据
const FollowUpDetailData = () => import("../containers/sales/followUpDetailData.vue");

// 盘古系统-统计分析-销售报表-日报数据
const DaliyReportData = () => import("../containers/sales/daliyReportData.vue");

// 飞鱼返款对账单详情
const FeiyuRefundDetails = () => import("../components/Feiyu/FeiyuRefundDetails.vue");

// 盘古系统-统计分析-市场报表-新渠道数据监测表
const NewChannelDataReport = () => import("../containers/market/newChannelDataReport.vue");

const newChannelTeamDataReport = () => import("../containers/market/newChannelTeamDataReport.vue");

const newChannelTeammateDataReport = () => import("../containers/market/newChannelTeammateDataReport.vue");

// 用户管理
const userManagement = () => import("../containers/permission/userManage.vue");

// 部门管理
const departmentManagement = () => import("../containers/permission/departmentManage.vue");

// 导出下载
const Export = () => import("../containers/Export.vue");

export default new Router({
  mode: "history",
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: "/",
      name: "550",
      component: Entry,
      redirect: "/cluesIndex",
      children: [
        // { path: '/index',meta:{ title:'销售工作台' }, name:'625',component: HomeIndex }, // 销售工作台
        {
          path: "/sales/tracking",
          meta: { title: "销售电话咨询" },
          name: "627",
          component: CluesModuleSalesTracking,
        }, // 销售电话咨询
        {
          path: "/managementBench",
          meta: { title: "管理工作台" },
          name: "778",
          component: Workbench,
        }, // 管理工作台
        {
          path: "/tableManage",
          meta: { title: "视图管理" },
          name: "888",
          component: viewManage,
        }, // 视图管理
        {
          path: "/cluesIndex",
          meta: { title: "客户管理" },
          name: "490",
          component: CluesIndex,
        }, // 客户管理
        {
          path: "/meetCluesIndex",
          meta: { title: "会场销售-客户管理" },
          name: "492",
          component: MeetCluesIndex,
        }, //会场销售-客户管理
        {
          path: "/clue/import/search",
          meta: { title: "导入结果查询" },
          name: "494",
          component: CluesModuleBatch,
        }, // 导入结果查询
        {
          path: "/clue/getnewclue",
          meta: { title: "获取新客户" },
          name: "1025",
          component: NewList,
        }, // 获取新客户
        {
          path: "/sales/SaleNewClueindex",
          meta: { title: "今日新客户" },
          name: "520",
          component: MeetNewClueList,
        }, // 今日新客户
        {
          path: "/sales/InvitationList",
          meta: { title: "邀约管理" },
          name: "salesInvitationList",
          component: InvitationList,
        }, // 今日新客户
        {
          path: "/sales/repeatConsult",
          meta: { title: "今日重复咨询" },
          name: "521",
          component: MeetRepeatConsult,
        }, // 今日重复咨询
        {
          path: "/sales/reservationCommucinate",
          meta: { title: "今日预约沟通" },
          name: "522",
          component: MeetReservationComm,
        }, // 今日预约沟通
        {
          path: "/sales/PublicPoolClueIndex",
          meta: { title: "公海池" },
          name: "652",
          component: SalePublicPoolClue,
        }, // 公海池
        {
          path: "/sales/myClient",
          meta: { title: "我的客户" },
          name: "661",
          component: MyClient,
        }, // 我的客户
        {
          path: "/sales/myStudent",
          meta: { title: "我的学员" },
          name: "662",
          component: MyStudent,
        }, // 我的学员
        {
          path: "/sales/GroupManagement",
          meta: { title: "群管理" },
          name: "663",
          component: GroupManagement,
        }, // 群管理
        {
          path: "/sales/ChatManagement",
          meta: { title: "聊天管理" },
          name: "664",
          component: ChatManagement,
        }, // 聊天管理
        {
          path: "/RecommendClue",
          meta: { title: "客户推荐" },
          name: "527",
          component: RecommendClueList,
        }, // 客户推荐
        {
          path: "/audition/list",
          meta: { title: "预约试听列表" },
          name: "1030",
          component: CluesInvitationAudition,
        }, // 预约试听列表
        {
          path: "/audition/specialapply",
          meta: { title: "特殊试听申请" },
          name: "1029",
          component: CluesSpeAudition,
        }, // 特殊试听申请
        {
          path: "/order/deposit",
          meta: { title: "我的定金" },
          name: "539",
          component: OrderDeposit,
        }, // 我的定金
        {
          path: "/order/unpaid",
          meta: { title: "未完款订单" },
          name: "559",
          component: OrderUnPaid,
        }, // 未完款订单
        {
          path: "/order",
          meta: { title: "所有订单" },
          name: "560",
          component: OrderManage,
        }, // 所有订单
        {
          path: "/order/return",
          meta: { title: "退回订单" },
          name: "650",
          component: OrderReturn,
        }, // 退回订单
        {
          path: "/order/refcheck",
          meta: { title: "待审核退款" },
          name: "733",
          component: OrderRefundCheck,
        }, // 待审核退款
        {
          path: "/order/auditManage",
          meta: { title: "待审核订单" },
          name: "563",
          component: OrderAuditManage,
        }, // 待审核订单
        {
          path: "/order/paySerial",
          meta: { title: "订单收款" },
          name: "567",
          component: OrderPaySerial,
        }, // 订单收款
        {
          path: "/order/OrderRefund",
          meta: { title: "订单退款" },
          name: "568",
          component: OrderRefund,
        }, // 订单退款
        {
          path: "/invoice/check",
          meta: { title: "开票审核" },
          name: "1028",
          component: OrderTicketOpeningAudit,
        }, // 开票审核
        {
          path: "/contractTemplateList",
          meta: { title: "电子合同模板" },
          name: "1066",
          component: ContractTemplateList,
        }, // 电子合同模板
        {
          path: "/order/agreements",
          meta: { title: "电子合同管理" },
          name: "1067",
          component: UserAgreementManage,
        }, // 电子合同管理
        {
          path: "/class",
          meta: { title: "产品管理" },
          name: "540",
          component: ProductIndex,
        }, // 产品管理
        {
          path: "/classPackage",
          meta: { title: "产品包管理" },
          name: "569",
          component: ProductPackIndex,
        }, // 产品包管理
        {
          path: "/CourseManagement",
          meta: { title: "课程管理" },
          name: "1024",
          component: CourseManagement,
        }, // 课程管理
        {
          path: "/classPropertyRelation",
          meta: { title: "产品性质权限" },
          name: "971",
          component: PropertyRelationList,
        }, // 产品性质权限
        {
          path: "/callCenter/CallRecords",
          meta: { title: "通话记录查询" },
          name: "547",
          component: CallRecord,
        }, // 通话记录查询
        {
          path: "/callCenter/agentStatus",
          meta: { title: "通时通次排行" },
          name: "549",
          component: AgentStatus,
        }, // 通时通次排行
        {
          path: "/callCenter/ExtMonitor",
          meta: { title: "座席状态监控" },
          name: "548",
          component: CallMonitor,
        }, // 座席状态监控
        {
          path: "/Report/:url/:title",
          meta: { title: "报表" },
          name: "866",
          component: ReportPages,
        }, // S02-高校市场业绩汇总
        {
          path: "/setting/distributesetting",
          meta: { title: "分配规则配置" },
          name: "1016",
          component: auditionIndex,
        }, // 分配规则配置
        {
          path: "/setting/tmkallotsetting",
          meta: { title: "TMK分配配置" },
          name: "1052",
          component: tmkAllotSetting,
        }, // 分配规则配置
        {
          path: "/clue/recovery",
          meta: { title: "回收规则配置" },
          name: "1053",
          component: recovery,
        }, // 分配规则配置
        {
          path: "/channelManagemen",
          meta: { title: "渠道管理" },
          name: "1032",
          component: channelManagement,
        }, // 渠道管理
        {
          path: "/userManagement",
          meta: { title: "用户管理" },
          name: "1067",
          component: userManagement,
        }, // 用户管理
        {
          path: "/setting/departmentManagement",
          meta: { title: "部门管理" },
          name: "1068",
          component: departmentManagement,
        }, // 部门管理
        {
          path: "/channelFenLeiManagement",
          meta: { title: "渠道分类管理" },
          name: "1033",
          component: channelFenLeiManagement,
        }, // 渠道分类管理
        {
          path: "/channel",
          meta: { title: "来源渠道管理" },
          name: "586",
          component: Channel,
        }, // 来源渠道管理
        {
          path: "/CustomerSource",
          meta: { title: "客户来源管理" },
          name: "587",
          component: CustomerSource,
        }, // 客户来源管理
        {
          path: "/maintenance/dictionary",
          meta: { title: "字典维护" },
          name: "870",
          component: DictionaryMaintenance,
        }, // 字典维护
        {
          path: "/maintenance/permission",
          meta: { title: "报表权限" },
          name: "872",
          component: ReportPermissions,
        }, // 报表权限
        {
          path: "/DiscountIndex",
          meta: { title: "优惠管理" },
          name: "581",
          component: DiscountIndex,
        }, // 优惠管理
        {
          path: "/messageList",
          meta: { title: "消息列表" },
          name: "704",
          component: MessageManage,
        }, // 消息列表
        {
          path: "/view/viewManage",
          meta: { title: "视图管理" },
          name: "710",
          component: ViewModuleManage,
        }, // 视图管理
        {
          path: "/performanceTarget",
          meta: { title: "业绩目标" },
          name: "753",
          component: PerformanceTarget,
        }, // 业绩目标
        {
          path: "/whiteList",
          meta: { title: "白名单" },
          name: "774",
          component: WhiteList,
        }, // 白名单
        {
          path: "/releaseRecord",
          meta: { title: "系统发布" },
          name: "943",
          component: ReleaseIndex,
        }, // 系统发布
        {
          path: "/SchoolManage",
          meta: { title: "合作校管理" },
          name: "943",
          component: SchoolManage,
        }, // 合作校管理
        {
          path: "/labelling/labellingManage",
          meta: { title: "用户群列表" },
          name: "743",
          component: LabellingModuleManage,
        }, // 用户群列表
        {
          path: "/information/messageCreate",
          meta: { title: "新建短信模板" },
          name: "745",
          component: messageCreate,
        }, // 新建短信模板
        {
          path: "/information",
          meta: { title: "我的模板列表" },
          name: "747",
          component: Information,
        }, // 我的模板列表
        {
          path: "/information/informationList",
          meta: { title: "消息统计" },
          name: "748",
          component: InformationList,
        }, // 消息统计
        {
          path: "/marketing/add",
          meta: { title: "新建活动推广页" },
          name: "750",
          component: MarketingAdd,
        }, // 新建市场营销活动
        {
          path: "/marketing/expand",
          meta: { title: "活动推广列表" },
          name: "750",
          component: MarketingExpand,
        }, // 新建市场营销活动
        {
          path: "/marketing/prize",
          meta: { title: "营销活动奖品池" },
          name: "1050",
          component: MarketingPrize,
        }, // 新建市场营销活动
        {
          path: "/marketing/squeeze",
          meta: { title: "新建市场营销活动" },
          name: "1049",
          component: MarketingSqueeze,
        }, // 新建市场营销活动
        {
          path: "/marketing/list",
          meta: { title: "市场营销活动列表" },
          name: "751",
          component: MarketingList,
        }, // 市场营销活动列表
        {
          path: "http://erp.songshuai.com/#/admin/student",
          meta: { title: "教务中心" },
          name: "706",
          component: 130520,
        }, // 教务中心
        {
          path: "http://www.171xue.com/searchuserinfo/index?key=XO2NVkjdFUaVvMwRt4VjFHJWcgExflRg0HD5DwtoqDH",
          meta: { title: "天王新查询" },
          name: "1035",
          component: 1305201,
        }, // 客户账号查询
        {
          path: "/clue/details",
          meta: { title: "客户详情" },
          name: "10001",
          component: MeetCluesModuleDetails,
        }, // 客户详情
        {
          path: "/clue/meetDetails",
          meta: { title: "会场销售客户详情" },
          name: "10002",
          component: MeetCluesModuleDetails,
        }, // 客户详情
        {
          path: "/clue/create",
          meta: { title: "创建订单" },
          name: "10003",
          component: OrderModuleCreate,
        }, // 创建订单
        {
          path: "/order/modify",
          meta: { title: "修改订单" },
          name: "10004",
          component: OrderModuleCreate,
        }, // 修改订单
        {
          path: "/order/audit",
          meta: { title: "订单审核" },
          name: "10005",
          component: OrderModuleAudit,
        }, // 订单审核
        {
          path: "/order/details",
          meta: { title: "订单详情" },
          name: "10005",
          component: OrderModuleAudit,
        }, // 订单详情
        {
          path: "/order/erpDetails",
          meta: { title: "订单详情" },
          name: "10005",
          component: OrderModuleAudit,
        }, // 订单详情 ERP
        {
          path: "/clue/addClientele",
          meta: { title: "新增客户" },
          name: "10007",
          component: CluesModuleNewUsers,
        }, // 新增客户
        {
          path: "/salemanage/addClientele",
          meta: { title: "推荐客户" },
          name: "10011",
          component: CluesModuleNewUsers,
        }, // 推荐客户
        {
          path: "/clue/addMeetClientele",
          meta: { title: "新增会场销售客户" },
          name: "10012",
          component: MeetCluesModuleNewUsers,
        }, // 新增会场销售客户
        {
          path: "/order/userfileupload",
          meta: { title: "合同详情" },
          name: "10013",
          component: UserFileUpload,
        }, // 用户资料上传
        {
          path: "/add/labelling",
          meta: { title: "新增标签" },
          name: "10017",
          component: AddLabelling,
        }, // 新增标签
        {
          path: "/add/view",
          meta: { title: "新增视图" },
          name: "10018",
          component: AddView,
        }, // 新增视图
        {
          path: "table/viewManage",
          meta: { title: "视图管理" },
          name: "10019",
          component: ViewModuleCustom,
        }, // 视图管理
        {
          path: "release/addReleaseInfo",
          meta: { title: "编辑发布记录" },
          name: "10020",
          component: AddReleaseInfo,
        }, // 编辑发布记录
        {
          path: "release/viewRelease",
          meta: { title: "查看发布记录" },
          name: "10021",
          component: ViewRelease,
        }, // 查看发布记录
        {
          path: "/clue/import/detail/:tid",
          meta: { title: "客户导入批次详情" },
          name: "10023",
          component: CluesModuleBatchDetail,
        }, // 客户导入批次详情
        {
          path: "/order/tryCatch",
          meta: { title: "订单异常处理" },
          name: "10025",
          component: OrderTryCatch,
        }, // 订单异常处理
        {
          path: "/Market/MarketDistrict",
          meta: { title: "市场调研地图" },
          name: "10031",
          component: MarketDistrict,
        }, // 市场调研地图
        {
          path: "/Market/VenueList",
          meta: { title: "会议管理" },
          name: "10032",
          component: VenueList,
        }, // 会议管理
        {
          path: "/PunchCard/PunchCardRecord",
          meta: { title: "营销会打卡记录" },
          name: "PunchCardRecord",
          component: PunchCardRecord,
        }, // 打卡记录
        {
          path: "/PunchCard/PunchCard",
          meta: { title: "营销会打卡" },
          name: "PunchCard",
          component: PunchCard,
        }, // 打卡
        {
          path: "/StaffPunchCard/StaffPunchCardRecord",
          meta: { title: "员工营销会打卡记录" },
          name: "StaffPunchCardRecord",
          component: StaffPunchCardRecord,
        }, // 员工打卡记录
        {
          path: "/StaffPunchCard/StaffPunchCard",
          meta: { title: "员工营销会打卡" },
          name: "StaffPunchCard",
          component: StaffPunchCard,
        }, //员工 打卡
        {
          path: "/Market/MarketSurveyList",
          meta: { title: "市调管理" },
          name: "10032",
          component: MarketSurveyList,
        }, // 市调管理
        {
          path: "/Market/SignInList",
          meta: { title: "签到详情" },
          name: "SignInList",
          component: SignInList,
        }, // 会议管理
        {
          path: "/RelatedExport",
          meta: { title: "招商会意向客户" },
          name: "SignInList",
          component: RelatedExport,
        }, // 招商会意向客户
        {
          path: "/FeiyuRefund",
          meta: { title: "线索返款对账单" },
          name: "FeiyuRefund",
          component: FeiyuRefund,
        }, // 线索返款对账单
        {
          path: "/statisticAnalysis/sales/SalesmanClueFollowUpReport",
          meta: { title: "电销线索跟进统计表" },
          name: "SalesmanClueFollowUpReport",
          component: SalesmanClueFollowUpReport,
        }, // 电销线索跟进统计表
        {
          path: "/statisticAnalysis/sales/performanceDetail",
          meta: { title: "业绩明细" },
          name: "PerformanceDetail",
          component: PerformanceDetail,
        }, // -统计分析-销售报表-业绩明细
        {
          path: "/statisticAnalysis/conference/meetingSignInDetail",
          meta: { title: "业绩明细" },
          name: "MeetingSignInDetail",
          component: MeetingSignInDetail,
        }, // -统计分析-销售报表-会议签到明细
        {
          path: "/statisticAnalysis/sales/followUpAllData",
          meta: { title: "业绩明细" },
          name: "FollowUpAllData",
          component: FollowUpAllData,
        }, // -统计分析-销售报表-跟进汇总数据
        {
          path: "/statisticAnalysis/sales/followUpDetailData",
          meta: { title: "业绩明细" },
          name: "FollowUpDetailData",
          component: FollowUpDetailData,
        }, // -统计分析-销售报表-跟进明细数据
        {
          path: "/statisticAnalysis/sales/daliyReportData",
          meta: { title: "业绩明细" },
          name: "DaliyReportData",
          component: DaliyReportData,
        }, // -统计分析-销售报表-日报数据
        {
          path: "/statisticAnalysis/market/newChannelDataReport",
          meta: { title: "新渠道数据监测表" },
          name: "NewChannelDataReport",
          component: NewChannelDataReport,
        }, // 新渠道数据监测表
        {
          path: "/statisticAnalysis/market/newChannelTeamDataReport",
          meta: { title: "新渠道客户分团队监测表" },
          name: "newChannelTeamDataReport",
          component: newChannelTeamDataReport,
        }, // 新渠道客户分团队监测表
        {
          path: "/statisticAnalysis/market/newChannelTeammateDataReport",
          meta: { title: "新渠道客户分团队成员监测表" },
          name: "newChannelTeammateDataReport",
          component: newChannelTeammateDataReport,
        }, // 新渠道客户分团队成员监测表
        {
          path: "/FeiyuRefundDetails",
          meta: { title: "线索返款对账单详情" },
          name: "FeiyuRefundDetails",
          component: FeiyuRefundDetails,
        }, // 线索返款对账单详情
        {
          path: "/Invitation/InvitationList",
          meta: { title: "邀约管理" },
          name: "10032",
          component: InvitationList,
        }, // 会议管理
        {
          path: "/Invitation/InvitedList",
          meta: { title: "营销会管理" },
          name: "10052",
          component: InvitedList,
        }, // 营销会管理
        {
          path: "/Record/BehaviorRecord",
          meta: { title: "用户行为记录" },
          name: "10042",
          component: BehaviorRecord,
        }, // 用户行为记录
        {
          path: "/Record/PushRecord",
          meta: { title: "推送记录" },
          name: "10045",
          component: PushRecord,
        }, // 推送记录
        {
          path: "/Record/MaterialBank",
          meta: { title: "素材库管理" },
          name: "10044",
          component: MaterialBank,
        }, // 推送记录
        {
          path: "/product/ContenDdisplay",
          meta: { title: "分类管理" },
          name: "10057",
          component: ContenDdisplay,
        }, // 分类管理
        {
          path: "/order/management",
          meta: { title: "订单管理" },
          name: "10033",
          component: OrdermanageList,
        }, // 订单管理
        {
          path: "/BasicsInformation/PublicSchoolManage",
          meta: { title: "公校管理" },
          name: "10032",
          component: PublicSchoolManage,
        }, // 会议管理
        {
          path: "/product/EstateManagement",
          meta: { title: "楼盘管理" },
          name: "10042",
          component: EstateManagement,
        },
        {
          path: "/BasicsInformation/DistrictManage",
          meta: { title: "片区管理" },
          name: "DistrictManage",
          component: DistrictManage,
        }, // 会议管理
        {
          path: "/VieCommodity/VieCommodity",
          meta: { title: "竞品管理" },
          name: "VieCommodity",
          component: VieCommodity,
        }, // 会议管理
        {
          path: "/tmks/TmkNewClueindex",
          meta: { title: "今日新客户" },
          name: "TmkNewClueList",
          component: TmkNewClueList,
        }, //电邀管理-今日新客户
        {
          path: "/tmks/InvitationList",
          meta: { title: "邀约管理" },
          name: "InvitationList",
          component: InvitationList,
        }, //电邀管理-今日新客户
        {
          path: "/tmks/tmkRCIndex",
          meta: { title: "今日重复咨询" },
          name: "TmkRepeatConsult",
          component: TmkRepeatConsult,
        }, //电邀管理-今日重复咨询
        {
          path: "/tmks/TmkReindex",
          meta: { title: "今日待跟进" },
          name: "TmkReservationList",
          component: TmkReservationList,
        }, //电邀管理-今日待跟进
        {
          path: "/tmks/Tmkindex",
          meta: { title: "我的线索" },
          name: "TmkMyClient",
          component: TmkMyClient,
        }, //电邀管理-我的线索
        {
          path: "/tmks/TmkAutoOutboundCall",
          meta: { title: "自动外呼" },
          name: "TmkAutoOutboundCall",
          component: TmkAutoOutboundCall,
        }, //电邀管理-自动外呼
        {
          path: "/tmks/TmkRobotOutboundCall",
          meta: { title: "机器人外呼" },
          name: "TmkRobotOutboundCall",
          component: TmkRobotOutboundCall,
        }, //电邀管理-机器人外呼
        {
          path: "/tmks/TmkPubindex",
          meta: { title: "电邀公池" },
          name: "TmkPublicPoolClue",
          component: TmkPublicPoolClue,
        }, //电邀管理-电邀公池
        {
          path: "/registerSignin",
          meta: { title: "现场签到" },
          name: "registerSignin",
          component: registerSignin,
        }, //电邀管理-我的线索2
        {
          path: "/PlayerIndex",
          meta: { title: "会议视频" },
          name: "PlayerIndex",
          component: PlayerIndex,
        }, //电邀管理-我的线索2
        {
          path: "/LabelWarning",
          meta: { title: "标签预警设置" },
          name: "LabelWarning",
          component: LabelWarning,
        }, // 标签预警设置
        {
          path: "/MyClients",
          meta: { title: "我的客户" },
          name: "LabelWarning",
          component: MyClients,
        }, // 我的客户
        {
          path: "/MyFriend",
          meta: { title: "我的好友" },
          name: "LabelWarning",
          component: MyFriend,
        }, //  我的好友
        // { path: '/VenueReceiptIndex', meta: { title: '会议视频'}, name: 'VenueReceiptList', component: VenueReceiptList },//回执单列表
        {
          path: "/tagAdminList",
          meta: { title: "标签管理" },
          name: "tagAdminList",
          component: TagAdminList,
        },
        {
          path: "/SopVideoManage",
          meta: { title: "视频管理" },
          name: "SopVideoManage",
          component: SopVideoManage,
        },
        {
          path: "/VenueReceiptIndex",
          meta: { title: "回执单列表" },
          name: "VenueReceiptList",
          component: VenueReceiptList,
        }, //回执单列表
        {
          path: "/Service/ServiceClassify",
          meta: { title: "服务内容分类" },
          name: "ServiceClassify",
          component: ServiceClassify,
        },//服务内容分类
        {
          path: "/Service/ServiceCollocate",
          meta: { title: "服务内容设置" },
          name: "ServiceCollocate",
          component: ServiceCollocate,
        },//服务内容设置
        {
          path: "/Market/StoreMap",
          meta: { title: "经销商门店地图" },
          name: "StoreMap",
          component: StoreMap,
        }, // 经销商门店地图
        {
          path: "/SopManage/ContentManagement",
          meta: { title: "内容管理" },
          name: "ContentManagement",
          component: ContentManagement,
        }, // 内容管理
        {
          path: "/SopManage/ContentDesc",
          meta: { title: "内容编辑" },
          name: "ContentDesc",
          component: ContentDesc,
        }, // 内容管理
        {
          path: "/tmkSalesManagement",
          meta: { title: "SOP管理" },
          name: "TmkSalesManagement",
          component: TmkSalesManagement,
        }, //SOP管理列表
        {
          path: "/tmkSalesPushRecord/:sopId",
          meta: { title: "推送记录" },
          name: "TmkSalesPushRecord",
          component: TmkSalesPushRecord,
        }, // 推送记录
        {
          path: "/tmkSalesUserBehavior/:sopId",
          meta: { title: "用户行为记录" },
          name: "TmkSalesUserBehavior",
          component: TmkSalesUserBehavior,
        }, // 用户行为记录
        {
          path: "/tmks/IndividualList",
          meta: { title: "邀约到店" },
          name: "TmksIndividualList",
          component: IndividualList,
        }, // 邀约到店
        {
          path: "/sales/IndividualList",
          meta: { title: "邀约到店" },
          name: "SalesIndividualList",
          component: IndividualList,
        }, // 邀约到店
        {
          path: "/Scheduling/SchedulingCalendar/:name/:id/:time",
          meta: { title: "排班日历" },
          name: "SchedulingCalendar",
          component: SchedulingCalendar,
        }, // 邀约到店
        {
          path: "/setting/salesmanScheduling",
          meta: { title: "电销排班" },
          name: "SalesmanScheduling",
          component: SalesmanScheduling,
        }, // 邀约到店
        {
          path: "/CampusManagement",
          meta: { title: "校区管理" },
          name: "CampusManagement",
          component: CampusManagement,
        }, // 校区管理
        {
          path: "/AdvertisingManagement",
          meta: { title: "广告管理" },
          name: "AdvertisingManagement",
          component: AdvertisingManagement,
        }, // 广告管理
        {
          path: "/Invitation/LiveInfo",
          meta: { title: "直播观看详情" },
          name: "LiveInfo",
          component: LiveInfo,
        }, // 直播观看详情
        {
          path: "/Agent/Agent",
          meta: { title: "代理员管理" },
          name: "Agent",
          component: Agent,
        }, // 代理员管理
        {
          path: "/export",
          meta: { title: "导出下载" },
          name: "export",
          component: Export,
        }, // 导出下载
      ],
    },

    {
      path: "/login",
      meta: { title: "登陆" },
      name: "10000",
      component: Login,
    }, // 登陆
    { path: "/live", meta: { title: "直播" }, name: "10008", component: Jump }, // 直播
    { path: "*", meta: { title: "404" }, name: "10009", component: Page404 }, // 404
    {
      path: "/registration",
      meta: { title: "用户合同" },
      name: "10010",
      component: CrmRegistrationForm,
    }, // 用户协议
    {
      path: "/order/usermaterial",
      meta: { title: "用户合同资料" },
      name: "10012",
      component: UserAgreementMaterial,
    }, // 用户合同资料
    {
      path: "/stage",
      meta: { title: "中转页面" },
      name: "10014",
      component: Stage,
    }, // 中转页面
    {
      path: "/registration/financial",
      meta: { title: "金融用户合同" },
      name: "10015",
      component: FinancialRegistration,
    }, // 金融用户协议
    {
      path: "/registration/agreementContract",
      meta: { title: "签署合同" },
      name: "10015",
      component: UserAgreementContract,
    }, // 签署合同
    {
      path: "/updatePwd",
      meta: { title: "修改密码" },
      name: "10016",
      component: UpdatePwd,
    }, // 修改密码
    {
      path: "/viewReport/:id",
      meta: { title: "查看报表" },
      name: "10022",
      component: ViewReport,
    }, // 查看报表
    {
      path: "/ErpLoginCrm/",
      meta: { title: "ERP登入CRM" },
      name: "10024",
      component: ErpLoginCrm,
    }, // ERP登入CRM
    {
      path: "/TMap",
      meta: { title: "片区地图" },
      name: "TMap",
      component: TMap,
    }, // ERP登入CRM
    {
      path: "/TMapAll",
      meta: { title: "片区地图" },
      name: "TMap",
      component: TMapAll,
    }, // ERP登入CRM
  ],
});
